var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesSummaryMinimum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 10,
    fill: "#FFC542",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3259 33.3973H18.2098V14.2455C18.2098 14.1105 18.0993 14 17.9643 14H16.2455C16.1105 14 16 14.1105 16 14.2455V35.3616C16 35.4967 16.1105 35.6071 16.2455 35.6071H39.3259C39.4609 35.6071 39.5714 35.4967 39.5714 35.3616V33.6429C39.5714 33.5078 39.4609 33.3973 39.3259 33.3973ZM20.9107 30.942H22.6295C22.7645 30.942 22.875 30.8315 22.875 30.6964V26.2768C22.875 26.1417 22.7645 26.0313 22.6295 26.0313H20.9107C20.7757 26.0313 20.6652 26.1417 20.6652 26.2768V30.6964C20.6652 30.8315 20.7757 30.942 20.9107 30.942ZM25.5759 30.942H27.2946C27.4297 30.942 27.5402 30.8315 27.5402 30.6964V20.875C27.5402 20.74 27.4297 20.6295 27.2946 20.6295H25.5759C25.4408 20.6295 25.3304 20.74 25.3304 20.875V30.6964C25.3304 30.8315 25.4408 30.942 25.5759 30.942ZM30.2411 30.942H31.9598C32.0949 30.942 32.2054 30.8315 32.2054 30.6964V23.269C32.2054 23.1339 32.0949 23.0234 31.9598 23.0234H30.2411C30.106 23.0234 29.9955 23.1339 29.9955 23.269V30.6964C29.9955 30.8315 30.106 30.942 30.2411 30.942ZM34.9063 30.942H36.625C36.76 30.942 36.8705 30.8315 36.8705 30.6964V18.4196C36.8705 18.2846 36.76 18.1741 36.625 18.1741H34.9063C34.7712 18.1741 34.6607 18.2846 34.6607 18.4196V30.6964C34.6607 30.8315 34.7712 30.942 34.9063 30.942Z",
    fill: "#FFC542"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesSummaryMinimum);
export default __webpack_public_path__ + "static/media/sales-summary-minimum.516dcd68784aa20936ec37387e497e4c.svg";
export { ForwardRef as ReactComponent };